import AbstractSubscriptionForm from "./AbstractSubscriptionForm";
import { LOADER_CONFIG } from "../assets/_loaderConfig";

const SUBSCRIBE_INPUT_CLIENT_ID_CLASS = "js-subscribe-input-client_id";
const SUBSCRIBE_INPUT_MAILING = "js-subscribe-input-mailing";
const SUBSCRIBE_BUTTON_CLASS = "js-unc-btn";

/**
 * Форма отписки от рассылки на странице unc page
 */
export default class UnсPageForm extends AbstractSubscriptionForm {
    constructor(formElem) {
        super(formElem);
        this.url = LOADER_CONFIG.api_unc.url;
        this._isSomeSubscriptionChecked = false;
        this._btnElem.disabled = this._isButtonDisabled();
    }

    _setElems() {
        this._inputClientIdElem = this.elem.querySelector(
            `.${SUBSCRIBE_INPUT_CLIENT_ID_CLASS}`,
        );
        this._inputSubscribeMailings = this.elem.querySelectorAll(`.${SUBSCRIBE_INPUT_MAILING}`);
        this._btnElem = this.elem.querySelector(`.${SUBSCRIBE_BUTTON_CLASS}`);
    }

    _getBody() {
        const body = {
            client_id: this._inputClientIdElem.value,
            mailing_ids: [...this._inputSubscribeMailings]
                .filter((item) => item.checked)
                .map((item) => item.id),
        };

        return body;
    }

    _toggleDisable(isDisable = true) {
        this._btnElem.disabled = isDisable;
        this._inputSubscribeMailings.forEach(input => input.disabled = isDisable);
    }

    _setSubscribeMailingsHandler() {
        this._inputSubscribeMailings.forEach(input => {
            input.addEventListener("change", () => {
                this._isSomeSubscriptionChecked = [...this._inputSubscribeMailings].some(item => item.checked);
                this._updateButtonState();
            });
        });
    }

    _updateButtonState() {
        this._btnElem.disabled = this._isButtonDisabled();
    }

    _isButtonDisabled() {
        return !this._isSomeSubscriptionChecked;
    }

    _setHandlers() {
        super._setHandlers();
        this._setSubscribeMailingsHandler();
    }

    _reset() {}
}
